import { Zap } from 'lucide-react';

/**
 * Badge "ÚLTIMAS VAGAS" — exibido quando 0 < vagasRestantes <= 10
 *
 * @param {number} vagasRestantes - Número de vagas restantes (para o texto opcional)
 * @param {string} variant - 'solid' | 'ghost' | 'overlay'
 *   - solid: fundo opaco (sobre cards/fundo claro)
 *   - ghost: fundo translúcido (para sobreposição)
 *   - overlay: fundo semi-transparente (para imagens)
 * @param {string} className - Classes Tailwind adicionais
 */
export const UltimasVagasBadge = ({
  vagasRestantes,
  variant = 'solid',
  className = '',
  showCount = false,
}) => {
  const baseClasses =
    'inline-flex items-center gap-1.5 font-black uppercase tracking-widest px-3 py-1 rounded-full text-[9px] transition-colors';

  const variantClasses = {
    solid:
      'bg-gradient-to-br from-wine to-wine-deep text-white shadow-lg shadow-wine/30',
    ghost: 'bg-wine/10 text-wine border border-wine/30',
    overlay: 'bg-white/95 text-wine shadow-lg shadow-black/20',
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      <Zap size={13} className="stroke-[2.5]" />
      <span>Últimas vagas</span>
      {showCount && vagasRestantes && (
        <span className="text-[8px] font-bold">({vagasRestantes})</span>
      )}
    </div>
  );
};

export default UltimasVagasBadge;
